module.exports = __webpack_public_path__ + "img/pic2.83d758d5.png";